<form [formGroup]="formName">
    <p-dropdown #miSelect [options]="presetValue" optionValue="labelValue" optionLabel="labelValue"  placeholder="{{'lbl_please_select'|translate}}" [formControlName]="field.attributeCode"></p-dropdown>
</form>
